"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Observable = void 0;
var Observable = /** @class */ (function () {
    function Observable() {
        this.listeners = [];
    }
    Observable.prototype.subscribe = function (listener) {
        var _this = this;
        this.listeners.push(listener);
        return function () {
            _this.listeners.splice(_this.listeners.indexOf(listener), 1);
        };
    };
    Observable.prototype.notify = function (value) {
        this.listeners.forEach(function (listener) { return listener(value); });
    };
    return Observable;
}());
exports.Observable = Observable;
//# sourceMappingURL=Observable.js.map